import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default function Text ({
  children,
  weight,
  bold,
  align,
  color,
  size,
  ellipsis = false,
  truncate = false,
  capitalize = false,
  uppercase = false,
  lowercase = false,
  block = false,
  wrap = true,
  className,
  tag = 'span',
  onClick
}) {
  const _className = classNames(
    { 'font-hairline': weight === 'hairline' },
    { 'font-thin': weight === 'thin' },
    { 'font-light': weight === 'light' },
    { 'font-normal': weight === 'normal' },
    { 'font-medium': weight === 'medium' },
    { 'font-semibold': weight === 'semibold' },
    { 'font-bold': bold || weight === 'bold' },
    { 'font-extrabold': weight === 'extrabold' },
    { 'font-black': weight === 'black' },
    { 'text-left': align === 'left' },
    { 'text-center': align === 'center' },
    { 'text-right': align === 'right' },
    { 'text-justify': align === 'justify' },
    { 'text-black': color === 'black' },
    { 'text-white': color === 'white' },
    { 'text-gray-500': color === 'gray' },
    { 'text-gray-200': color === 'lightgray' },
    { 'text-error': color === 'red' },
    { 'text-available': color === 'green' },
    { 'text-green-400': color === 'lightgreen' },
    { 'text-yellow-400': color === 'yellow' },
    { 'text-primary-500': color === 'primary' },
    { 'text-xs': size === 'xs' },
    { 'text-sm': size === 'sm' },
    { 'text-base': size === 'base' },
    { 'text-lg': size === 'lg' },
    { 'text-xl': size === 'xl' },
    { 'text-2xl': size === '2xl' },
    { 'text-3xl': size === '3xl' },
    { 'text-4xl': size === '4xl' },
    { 'text-5xl': size === '5xl' },
    { 'text-6xl': size === '6xl' },
    { capitalize: capitalize },
    { uppercase: uppercase },
    { lowercase: lowercase },
    { block: block || truncate },
    { truncate: truncate },
    { 'whitespace-nowrap whitespace-no-wrap': wrap === false },
    { 'overflow-ellipsis overflow-hidden': ellipsis === true },
    className
  )

  const elementProps = {
    className: _className,
    onClick: onClick
  }

  if (tag === 'p') {
    return (
      <p {...elementProps}>
        {children}
      </p>
    )
  }

  if (tag === 'div') {
    return (
      <div {...elementProps}>
        {children}
      </div>
    )
  }

  return (
    <span {...elementProps}>
      {children}
    </span>
  )
}

Text.propTypes = {
  bold: PropTypes.oneOfType([
    PropTypes.bool
  ]),
  weight: PropTypes.oneOf([
    'hairline',
    'thin',
    'light',
    'normal',
    'medium',
    'semibold',
    'bold',
    'extrabold',
    'black'
  ]),
  align: PropTypes.oneOf([
    'left',
    'center',
    'right',
    'justify'
  ]),
  color: PropTypes.oneOf([
    'white',
    'lightgray',
    'black',
    'gray',
    'red',
    'green',
    'yellow',
    'primary'
  ]),
  size: PropTypes.oneOf([
    'xs',
    'sm',
    'base',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl'
  ]),
  className: PropTypes.string,
  ellipsis: PropTypes.bool,
  truncate: PropTypes.bool,
  capitalize: PropTypes.bool,
  uppercase: PropTypes.bool,
  lowercase: PropTypes.bool,
  wrap: PropTypes.bool,
  block: PropTypes.bool
}
